import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NavService } from '@app/core/service/navServices/nav-services.service';
import { FINANCIAL_PERMISSION_LABEL } from '@app/core/service/financial-analysis/financial-analysis-api.service';

/**
 * `/dashboard` es la pantalla de inicio del oficial. Quien tiene el permiso "costos vs utilidad"
 * ve el Análisis Económico; el resto sigue cayendo en el Tablero de Reservaciones como antes.
 * El backend valida el mismo permiso, esto solo decide a dónde mandar al usuario.
 */
export const financialDashboardGuard: CanActivateFn = async () => {
  const navService = inject(NavService);
  const router = inject(Router);
  if (await navService.hasPermissionLabels(FINANCIAL_PERMISSION_LABEL)) return true;
  return router.parseUrl('/indicators/reservation-board');
};
